import {Injectable} from '@angular/core';
import {AuthService} from './auth.service';
import {Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot} from '@angular/router';
import {UserService} from '../../service/user.service';
import {UserAuthentifie} from 'src/app/model/UserAuthentifie';
import { CustomLoadingService } from 'src/app/service/custom-loading.service';
@Injectable({
    providedIn: 'root'
})
export class AuthGuardService implements CanActivate {
    public currentUser: UserAuthentifie;
    constructor(private authService: AuthService,
         private router: Router,

        ) {
    }
canActivate(route: ActivatedRouteSnapshot): boolean {
  const value = localStorage.getItem("currentUser");
  if (!value) return false;
  this.currentUser = JSON.parse(value);

  const authorities = this.currentUser.authorities as Array<{ name: string }>;

  const isSuperAdmin = authorities.some(auth => auth.name === 'ROLE_SUPER_ADMIN');
  if (isSuperAdmin) {
    return this.authService.isLogged();
  }

  const requiredRoles = route.data.name;
  if (!requiredRoles || requiredRoles.length === 0) {
    return this.authService.isLogged();
  }

  const userRoles = authorities.map(auth => auth.name);
  const hasRole = requiredRoles.some(role => userRoles.includes(role));
  if (hasRole) {
    return this.authService.isLogged();
  }

  this.router.navigateByUrl('acces-denied');
  return false;
}
    
}